import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import './Login.css';

export default function Login() {
  const [tab, setTab]           = useState('login');
  const [username, setUsername] = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate('/today', { replace: true });
  }, [isAuthenticated, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const endpoint = tab === 'login' ? '/auth/login' : '/auth/register';
      const payload  = tab === 'login'
        ? { username, password }
        : { username, email, password };
      const res = await api.post(endpoint, payload);

      if (tab === 'register' && res.data.pending) {
        setSuccess(res.data.message || '¡Usuario registrado con éxito! Espera a que el administrador te dé de alta.');
        setUsername('');
        setEmail('');
        setPassword('');
        return;
      }

      const { access_token, user } = res.data;
      login(access_token, user);
      navigate('/today', { replace: true });
    } catch (err) {
      if (tab === 'login') {
        const serverMsg = err.response?.data?.error || '';
        if (err.response?.status === 403) {
          setError(serverMsg);
        } else {
          setError('Error de autenticación');
        }
      } else {
        setError(
          err.response?.data?.error ||
          'Error al registrarse. Por favor, inténtalo de nuevo.'
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-bg-circle login-bg-circle-1" />
      <div className="login-bg-circle login-bg-circle-2" />

      <div className="login-container">
        <div className="login-logo">
          <span className="login-logo-icon">🏋️</span>
          <h1 className="login-title">GYM Tracker</h1>
          <p className="login-subtitle">Registra cada repetición. Domina cada serie.</p>
        </div>

        <div className="login-card">
          <div className="login-tabs">
            <button
              className={'login-tab' + (tab === 'login' ? ' active' : '')}
              onClick={() => { setTab('login'); setError(''); setSuccess(''); }}
              type="button"
            >
              Iniciar sesión
            </button>
            <button
              className={'login-tab' + (tab === 'register' ? ' active' : '')}
              onClick={() => { setTab('register'); setError(''); setSuccess(''); }}
              type="button"
            >
              Registrarse
            </button>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label">Usuario</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa tu usuario"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            {tab === 'register' && (
              <div className="form-group">
                <label className="form-label">Correo electrónico</label>
                <input
                  className="form-input"
                  type="email"
                  placeholder="Ingresa tu correo electrónico"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input
                className="form-input"
                type="password"
                placeholder="Ingresa tu contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete={tab === 'login' ? 'current-password' : 'new-password'}
              />
            </div>

            {error && <div className="login-error">{error}</div>}
            {success && <div className="login-success">{success}</div>}

            <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
              {loading
                ? <span className="spinner spinner-sm" />
                : tab === 'login' ? 'Iniciar sesión' : 'Crear cuenta'
              }
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
